import React, { lazy } from 'react';

import { getPanelModelViewer, CMS_PANEL_MODELS } from './CmsPanels.js';

import PageDefaultModel from './components/model/pages/PageDefaultModel.js';
import PageMenuModel from './components/model/pages/PageMenuModel.js';
import PageBlogModel from './components/model/pages/PageBlogModel.js';
import PostDefaultModel from './components/model/posts/PostDefaultModel.js';
// const PageTest = lazy(() => import('./components/model/pages/PageTest'));

// Pages
import PageDefault from './components/model/pages/PageDefault';
import PageMenu from './components/model/pages/PageMenu';
import PageBlog from './components/model/pages/PageBlog';
import PostDefault from './components/model/posts/PostDefault';

export const CMS_PAGE_MODEL_DEFAULT = PageDefaultModel;
export const CMS_PAGE_MODELS = [
	PageDefaultModel,
	PageMenuModel,
	PageBlogModel,
];

export const CMS_POST_MODEL_DEFAULT = PostDefaultModel;
export const CMS_POST_MODELS = [PostDefaultModel];

export function getAvailableCmsTypes() {
	return ['page', 'panel', 'post'];
}

export function getModels(type = null) {
	return [...CMS_PAGE_MODELS, ...CMS_PANEL_MODELS, ...CMS_POST_MODELS].filter(model => model && (type === null || type === model.type));
}

export function getModel(type, name) {
	return getModels(type).find(model => model.name === name);
}

export function getCmsViewer(cms) {
	let viewer = null;
	switch(cms.type) {
	case 'panel':
		viewer = getPanelModelViewer;
		break;

	case 'post':
		viewer = getPostModelViewer;
		break;

	case 'page':
	default:
		viewer = getPageModelViewer;
		break;
	}

	return viewer && viewer(cms.model);
}

export function getPageModelViewer(model) {
	switch(model) {
	// Add custom model page
	// case 'xyz':
	//     return <PageXyz page={this.props.page} />;
	case 'pageMenu':
		return PageMenu;

		// case 'test':
		//     return PageTest;

	case 'blog':
		return PageBlog;

	case 'default':
	default:
		return PageDefault;
	}
}

export function getPostModelViewer(model) {
	switch(model) {
	case 'post':
	case 'default':
	default:
		return PostDefault;
	}
}
